export default __webpack_public_path__ + "static/media/Gellix-SemiBoldItalic.fb26e70a.woff2";